import React, {useEffect, useRef, useState} from "react";
import "./css/StockSplit.css";
import {useRefreshContext} from "../context/RefreshContext";
import {deleteContractNote, fetchManualContractNoteNo, saveContractNote} from "@portfolio/utils/PFService"; // Import the new CSS file
import { usePopupStack } from "../../contexts/PopupStackContext";

const StockSplit = ({ symbol, beforeSplitQuantityPassed, onClose, onSave,clientId,isDisplayClick,contractNoteDTO }) => {
    const [date, setDate] = useState(new Date().toISOString().split("T")[0]); // Default to today
    const [afterSplitQuantity, setAfterSplitQuantity] = useState(0); // Default to 0
    const [beforeSplitQuantity, setBeforeSplitQuantity] = useState(0); // Default to 0
    const [narration, setNarration] = useState("");
    const formRef = useRef(null);
    const {refreshPFdata} = useRefreshContext(); // 🔹 Subscribe to global refresh
    const { push, pop } = usePopupStack();

    useEffect(() => {
        if(isDisplayClick){
            setAfterSplitQuantity(contractNoteDTO.transactions[0].afterSplitQuantity); //use existing passed afterSplitQuantity for edit/display click
            setNarration(contractNoteDTO.transactions[0].narration);
            setBeforeSplitQuantity(contractNoteDTO.transactions[0].beforeSplitQuantity);  //use existing passed beforeSplitQuantity for edit/display click
        } else{
            setBeforeSplitQuantity(beforeSplitQuantityPassed);
        }
    }, []);

    useEffect(() => {
        const popupEntry = { onClose }; // 🔥 Use the prop directly
        push(popupEntry);
        return () => pop();
    }, []);

    const handleClose = () => {
        pop(); // 🧹 Make sure to remove this popup from the stack manually
        onClose();
    };

    const handleSave = async () => {
        let manualNote = contractNoteDTO?.contractNote?.contractNoteNo || "";
        if(!isDisplayClick) {
            manualNote = await fetchManualContractNoteNo("SPLIT-CNT-"); // ✅ Now we get the actual value
            //console.log("📌 manualContractNoteNo BEFORE using:", manualNote); // ❌ Logs empty array []
        }

        if (!afterSplitQuantity || isNaN(afterSplitQuantity) || afterSplitQuantity <= 0) {
            alert("Please enter a valid quantity after the split.");
            return;
        }
        const formData = new FormData(formRef.current);

        const parsedAfterSplitQuantity = parseInt(afterSplitQuantity, 10);
        const narrationText = narration; // ✅ Correct usage of `useState` variable
        const quantity=parsedAfterSplitQuantity-beforeSplitQuantity;

        // Construct ContractNoteDTO
        const newContractNote = {
            contractNote: {
                contractNoteNo: manualNote,
                clientId: clientId,
                brokerName: "",
                tradeDate: formData.get("date"),
                cnoteType: "SPLIT",
            },
            cnotesCharge: {
                contractNoteNo: "",
                securitiesTransactionTaxNetTotal:"",
                stampDutyNetTotal: "",
                gstTotal: "",
                payInPayOutObligationNetTotal: "",
                otherCharges: "",
                netAmountNetTotal: "",
            },
            transactions: [  // ✅ Ensure this is an array
                { // ✅ Include idx here
                    type: "SplitTransactionDTO",
                    contractNoteNo: manualNote,
                    clientId: clientId,
                    symbol: symbol,
                    transactionType: "SPLIT",
                    quantity: quantity,
                    /*                    weightedAvgPrice: 0,
                                        brokerage: 0,
                                        totalValue: 0,
                                        netQuantity: parsedQuantity,
                                        netObligation: 0,*/
                    tradeDate: formData.get("date"),
                    afterSplitQuantity:parsedAfterSplitQuantity,
                    beforeSplitQuantity:beforeSplitQuantity,
                    narration: narrationText ?? "" // ✅ Ensure narration is not null
                }
            ],
            cnoteType: "SPLIT"
        };

        const result =await saveContractNote(newContractNote, isDisplayClick); // Wait for save to complete
        if (result.success) {
            refreshPFdata(); // ✅ Now refreshes AFTER the save is successful
            onClose(); // Close the popup after successful Save
        }
    };

    const handleDelete = async () => {
        try {
            const result =await deleteContractNote(contractNoteDTO.contractNote.contractNoteNo); // Wait for save to complete
            if (result.success) {
                refreshPFdata(); // ✅ Now refreshes AFTER the save is successful
                onClose(); // Close the popup after successful Save
            }
        } catch (error) {
            console.error("Error deleting Split:", error);
        }
    };

    return (
        <div className="stocksplit-overlay">
            <form ref={formRef}>
                <div className="stocksplit-popup" onClick={(e) => e.stopPropagation()}>
                    <div className="header-row">
                        <h3>Stock Split</h3>
                        <h3>{clientId}</h3>
                    </div>
                    <div className="form-group">
                        <label className="general-label">Asset Name:</label>
                        <input
                            type="string"
                            value={symbol}
                            disabled
                        />
                    </div>

                    <div className="form-group">
                        <label className="general-label">Date:</label>
                        <input name="date" type="date" value={date} onChange={(e) => setDate(e.target.value)}/>
                    </div>

                    <div className="form-group">
                        <label className="general-label">Bal. Quantity before Split:</label>
                        <input
                            type="string"
                            value={beforeSplitQuantity != null ? beforeSplitQuantity.toLocaleString() : "0"}
                            disabled
                        />
                    </div>

                    <div className="form-group">
                        <label className="general-label">Bal. Quantity after Split:</label>
                        <input
                                type="number"
                                value={afterSplitQuantity}
                                onChange={(e) => setAfterSplitQuantity(e.target.value)}
                                min="1"
                            />
                        </div>
                        <div className="form-group">
                            <label className="general-label">Narration:</label>
                            <textarea
                                value={narration}
                                onChange={(e) => setNarration(e.target.value)}
                                rows="3"
                            />
                        </div>
                        <div className="contract-buttons">
                            {isDisplayClick && (
                                <button type="button" className="delete-button" onClick={handleDelete}>
                                    Delete CNote
                                </button>
                            )}
                            <div className="right-buttons">
                                <button type="button" className="save-button" onClick={handleSave}>Save</button>
                                <button type="button" className="cancel-button" onClick={handleClose}>Cancel</button>
                            </div>
                        </div>
                    </div>
            </form>
        </div>
)
;
};

export default StockSplit;
